// app/assets/javascripts/ageParts.js から、 createBirthYears のみ抽出.
import dayjs from 'dayjs';

const currentYear = () =>  {
  return new Date().getFullYear();
}

// 西暦に対応する"平成NN年"などの年号を返す
// TODO ES6仕様に書き直す
const getNengoText = year => {
  if (year == 1989) {
    return '昭和64・平成1年';
  } else if (year === 2019) {
    return '平成31・令和1年';
  }

  let jpYear;
  let nengo;
  if(year > 2019) {
    jpYear = year - 2018;
    nengo = '令和';
  } else if(year > 1989){
    jpYear = year - 1988;
    nengo = '平成';
  } else {

    jpYear = year - 1925;
    nengo = '昭和';
  }
  return nengo + jpYear + '年';
}

// [{ value: 24, text: '1992/平成24年' }, { value: 23, text: '1991/平成23年' }, ...] という、「生まれた年」用の配列を返す。
// DOMやjQueryに依存せず、純粋なオブジェクトの配列を返す。
// options:
//   withoutNengo: '/平成24年'などの年号部分を付けない。default: false
//   yearSuffix: 西暦の後に付けるテキスト。{ withoutNengo: '', yearSuffix: '年' }などとして使う。default: ''
//   baseYear: 基準年(西暦)。ago:参照。default: 現在の年
//   ago: 基準年から何年前を最新の項目とするか。default: 24
//   yearTo: 西暦何年前までを最古の項目とするか。default: 1932
const createYears = (defaultAgo, defaultYearTo, options) => {
  options = options || {};
  const withoutNengo = options.withoutNengo || false;
  const yearSuffix = options.yearSuffix || '';
  const baseYear = options.baseYear || currentYear();

  const ago = options.ago || defaultAgo;
  const yearTo = options.yearTo || defaultYearTo;
  const results = [];
  for (let year = baseYear - ago; year >= yearTo; year--) {
    const age = baseYear - year;
    const nengoText = withoutNengo ? '' : '/' + getNengoText(year);
    results.push({ value: age, text: '' + year + yearSuffix + nengoText });
  }
  return results;
}

export const guessedQualifiedYears = (birthYear) => {
  if(birthYear === null) return null;
  if(birthYear >= 1988){
    return {
      firstHalf: birthYear + 24,
      lastHalf: birthYear + 25
    };
  }else{
    return {
      firstHalf: birthYear + 22,
      lastHalf: birthYear + 23
    };
  }
}

export const guessedBirthYear = (birthYear) => {
  if(birthYear === null) return null;
  const age = dayjs().year() - birthYear;
  const tenDigits = Math.floor((age / 10)) * 10;
  const oneDigits = age - tenDigits;
  const suffixText = oneDigits < 5 ? '代前半' : '代後半';

  return `${tenDigits}${suffixText}`;

}

export default {
  // 誕生年
  createBirthYears: options => createYears(24, 1932, options),
  // 資格取得年
  createQualifiedYears: options => createYears(-1, 1954, options),
  // 登録販売者のための誕生年
  createRegisteredSellerBirthYears: options => createYears(20, 1932, options),
  // 登録販売者のための誕生年
  createPharmacyClerkBirthYears: options => createYears(20, 1932, options)
}